export enum DragDropScreenTypes {
	UPDATE_DRAGGING = "@dragDropScreen/UPDATE_DRAGGING",
	RESET_DRAG_DROP = "@dragDropScreen/RESET_DRAG_DROP",
}

export interface DragDropScreenState {
	readonly dragDropScreen: {
		data: boolean;
	};
}

export interface UpdateDragDropScreenValue {
	type: typeof DragDropScreenTypes.UPDATE_DRAGGING;
	payload: {
		data: boolean;
	};
}

export interface ResetReducerDragDropScreen {
	type: typeof DragDropScreenTypes.RESET_DRAG_DROP;
}

export type DragDropScreenActionTypes = UpdateDragDropScreenValue | ResetReducerDragDropScreen;
